const debug = !process.env.AWS_SESSION_TOKEN && false

const camelRegex = new RegExp(/([A-Z])(?=[a-z])/g)
const firstChr = /^[a-z]/u

export const camelToDisplay = (s: string) => {
  let regexRes: RegExpExecArray | null = null
  let display: string = ''
  let lastIdx: number = 0
  do {
    regexRes = camelRegex.exec(s)
    const nextIdx = regexRes?.index ?? s.length

    const newSub = s.substring(lastIdx, nextIdx)
    debug && console.log('To Camel', { newSub, nextIdx, lastIdx })
    display += `${lastIdx ? ' ' : ''}${newSub}`
    lastIdx = nextIdx
  } while (regexRes)

  return display.replace(firstChr, (x) => x.toUpperCase())
}

export const noSpace = (s: string) => s.replace(/( |&|\/)/g, '')
export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)
export const toCamelCase = (attName: string) =>
  attName
    .split(' ')
    .map((g, i) => {
      g = (i === 0 ? g.charAt(0).toLowerCase() : g.charAt(0).toUpperCase()) + g.slice(1)
      return g
    })
    .join('')
